import ApiClientFactory from '@/api/apiClientFactory';

import {
  PriceAction,
  PriceGetter,
  PriceModule,
  PriceMutation,
  PriceState
} from './price.module-types';

export const priceModule: PriceModule = {
  namespaced: true,
  state: {
    [PriceState.stickerPriceList]: null
  },
  mutations: {
    [PriceMutation.setStickerPriceList]: (state, payload) => {
      state[PriceState.stickerPriceList] = payload;
    }
  },
  actions: {
    [PriceAction.loadStickerPriceList]: async ({ commit }) => {
      commit(
        PriceMutation.setStickerPriceList,
        await new ApiClientFactory().priceClient().getStickerPrices()
      );
    }
  },
  getters: {
    [PriceGetter.stickerPriceList]: (state) =>
      state[PriceState.stickerPriceList]
  }
};
